import { TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import * as z from 'zod';

export const statusByReason: { [key: string]: TripMatchStatus } = {
  'Match Error': TripMatchStatus.MatchZicassoMatchError,
  'Not Accepted': TripMatchStatus.MatchZicassoCanceled,
  'Not Fulfilled': TripMatchStatus.MatchZicassoCanceled,
  'Traveler Canceled': TripMatchStatus.MatchTravelerCanceled,
  'Partner Canceled': TripMatchStatus.MatchPartnerCanceled,
};

// Return array of reasons based on status
// Sold trip matches cannot be canceled
export const filterOptionsByTMStatus = (status: TripMatchStatus): string[] => {
  const reasonOptions: string[] = [];
  switch (status) {
    case TripMatchStatus.MatchPending:
      reasonOptions.push('Match Error');
      reasonOptions.push('Not Accepted');
      return reasonOptions;
    case TripMatchStatus.MatchAccepted:
      reasonOptions.push('Not Accepted');
      reasonOptions.push('Not Fulfilled');
      return reasonOptions;
    case TripMatchStatus.MatchActive:
    case TripMatchStatus.MatchPostponed:
    case TripMatchStatus.MatchInactive:
      reasonOptions.push('Traveler Canceled');
      reasonOptions.push('Partner Canceled');
      return reasonOptions;
    default:
      return reasonOptions;
  }
};

export const MatchCancelSchema = z.object({
  reason: z.string().min(1, { message: 'Select a reason' }),
  comments: z.string().min(1, { message: 'Please add a comment' }),
});
